import IcFilters from './IcFilters'

export default IcFilters
